<template>
  <div>
    <div class="upload-content">
      <img :src="url" class="upload-img" v-if="url" />
      <div>
        <div class="upload">
          <div class="label"><span>*</span>上传小程序端封面图</div>
          <el-upload
            class="upload"
            ref="upload"
            action="https://up-z2.qiniup.com"
            :show-file-list="false"
            :data="uploadData"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
          >
            <el-button size="small" icon="el-icon-upload2" :loading="loading"
              >上传</el-button
            >
          </el-upload>
        </div>
        <div class="tips">只能上传jpg/png格式文件，建议尺寸690*244px</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getQiNiuYunToken } from '@/api/common';
import { getOldCustomizeUrl, updateOldCustomizeUrl } from '@/api/goods';

export default {
  name: 'UploadCustomize',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploadData: {
        token: '',
      },
      domain: '',
      url: '',
      loading: false,
    };
  },
  mounted() {
    this.getQniuyunToken();
    this.getOldUrl();
  },
  methods: {
    getOldUrl() {
      getOldCustomizeUrl(this.id).then((res) => {
        if (res.success) {
          this.url = res.data.customizeUrl;
        }
      });
    },
    getQniuyunToken() {
      getQiNiuYunToken().then((res) => {
        if (res.success && res.data) {
          const { domain, token } = res.data;
          this.uploadData.token = token;
          this.domain = domain;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!(isJPG || isPNG)) {
        this.$message.error('图片只能是 JPG 或 PNG 格式！');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
      }
      const isPass = (isJPG || isPNG) && isLt2M;

      if (isPass) {
        this.loading = true;
      }
      return isPass;
    },
    handleSuccess(res) {
      const completeUrl = `${this.domain}${res.key}`;
      this.updateUrl({
        id: this.id,
        customizeUrl: completeUrl,
      });
    },
    handleError(err) {
      this.loading = false;
      this.$message.error(`上传失败！错误：${err}`);
      this.getQniuyunToken();
    },
    updateUrl(params) {
      updateOldCustomizeUrl(params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.url = params.customizeUrl;
          this.$message.success('上传成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.upload-content
  display flex
  align-items center
  justify-content flex-end
  margin-bottom 24px;
  .upload-img
    width 188px
    height 80px
    object-fit cover
    margin-right 12px
  .label
    color #999
    padding-right 20px
    span
      color #ff3b30
  .upload
    display flex
    align-items center
    justify-content flex-end
  .tips
    color #999
    margin-top 16px
</style>
